import { useShowSfwSite } from 'src/client/helpers/useFeatureFlags';
import { useSelector } from 'src/client/redux';

/**
 * These thumbnails are on the storage server, in a directory called 'static-splash'
 * for each site. Each top level directory is the same.
 *
 * e.g. /d1/content/published/
 *
 * `thumbnail.uuid` is the model's UUID for a model, and the galleryUUID from
 * @type ImageMediaResponse
 *
 * CDN URL: https://gccdn.metartnetwork.com/E6B595104E3411DF98790800200C9A66/media/static-splash/nude/desktop-hero.mp4
 *
 * Example of the directory structure is below:
 *
 * ├── non-nude/
 * │   ├── classics/
 * │   │   └── [guid].jpg
 * │   ├── galleries/
 * │   ├── models/
 * │   ├── movies/
 * │   ├── bottom-banner.[mp4|webm]
 * │   ├── desktop-hero.[mp4|webm]
 * │   └── mobile-hero.[mp4|webm]
 * ├── nude/
 * │   └── etc...
 */

export type GalleryType = 'movies' | 'models' | 'galleries' | 'classics';

export const useMediaUrl = () => {
  const { contentCdnUrl, cdnUrl } = useSelector((state) => state.app);
  const site = useSelector((state) => state.site);
  const showSfwSite = useShowSfwSite();

  const nude = showSfwSite ? 'non-nude' : 'nude';

  // Set this in the `.env` file to point at the `public/static/local-static-splash`
  // folder for local development.
  const localCdnTesting = process.env.REACT_APP_LOCAL_STATIC_SPLASH === 'true';

  const mediaUrl = localCdnTesting
    ? `${cdnUrl}/local-static-splash/${site.UUID}/${nude}`
    : `${contentCdnUrl}/${site.UUID}/media/static-splash/${nude}`;

  return mediaUrl;
};
